module.exports = __webpack_public_path__ + "./images/7d9481ab4dd20cdfdb8a2fe2f3824a5d.webp";